//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState } from 'vuex'
import activateResourcesFilter from '~/mixins/ResourceFilterFunctions/resources.js';
export default {
	mixins: [activateResourcesFilter],
	async fetch() {
		await this.$store.dispatch('resourcesStore/getResources', this.queries.allCategories);
	},
	computed: {
		...mapState({
			filterDropdown: ({ dropdownStore: {filterDropdown} }) => filterDropdown,
			filter: ({ filtersStore: {filter} }) => filter,
			queries: ({ resourcesStore: {queries} }) => queries,
			allCategories: ({ resourcesStore: {allCategories} }) => allCategories,
		}),
	},
}
